import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ProjectPermitTaskServiceCreateResponseJson } from '@vmspdb/definitions';
import { Paginated } from '@vmspdb/ui/domain';
import * as fromPaginatedPermitTask from './paginated-permit-task.reducer';

export const selectPaginatedPermitTaskState =
  createFeatureSelector<fromPaginatedPermitTask.PaginatedPermitTaskState>(
    fromPaginatedPermitTask.paginatedPermitTaskFeatureKey,
  );

export const selectPaginatedPermitTasks = createSelector(
  selectPaginatedPermitTaskState,
  (state) => state.items,
);

export const selectPaginatedPermitTasksForTable = createSelector(
  selectPaginatedPermitTaskState,
  (state): Paginated<ProjectPermitTaskServiceCreateResponseJson> => state,
);

export const selectPaginatedPermitTaskError = createSelector(
  selectPaginatedPermitTaskState,
  (state) => state.error,
);
